import { Link } from "react-router-dom";
import CategoryTag from "@/components/base/CategoryTag";
import type { WorkItem } from "@/mocks/works";

export default function WorkCard({ item }: { item: WorkItem }) {
  const isMusic = item.category === "music";

  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className={`w-full overflow-hidden bg-background-200 ${isMusic ? "aspect-square" : "aspect-[3/4]"}`}>
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 森泽佳奈${item.type}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4 flex flex-col flex-1">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <CategoryTag label={item.type} tone={isMusic ? "accent" : "primary"} />
          <span className="text-xs text-foreground-500">{item.year}</span>
        </div>
        <h3 className="font-heading font-semibold text-base text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1.5 line-clamp-1">{item.role}</p>
      </div>
    </Link>
  );
}